import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import PageHeader from '../components/organisms/PageHeader';
import SystemCardGrid from '../components/organisms/SystemCardGrid';
import SearchBar from '../components/molecules/SearchBar';
import Loading from '../components/atoms/Loading';

import { DEFAULT_PAGE_DESCRIPTION } from '../data/demoSystems';
import { fetchComplaintTypes } from '../redux/complaintType/actions';
import { setIsEdit } from '../redux/appDetails/reducer';


export default function ComplaintManagementPage({
  title = 'Complaint Management',
  description = DEFAULT_PAGE_DESCRIPTION,
  createLabel = 'Create New Form',
  onCreateForm,
  onConfigure,
  onOpen,
  onTitleClick,
  onDescriptionClick,
  onSearch,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [search, setSearch] = useState('');

  // Get complaint type data from Redux
  const {
    complaintList = [],
    loading = false,
    error = null,
  } = useSelector((state) => state.complaintType ?? {});

  // Fetch complaint types from API
  useEffect(() => {
    dispatch(setIsEdit({ data: false }));
    dispatch(fetchComplaintTypes());
  }, [dispatch]);


  // Filter systems according to search
  const filteredSystems = useMemo(() => {
    const query = search.trim().toLowerCase();

    if (!query) {
      return complaintList;
    }

    return complaintList.filter((system) => {
      const searchableText = [
        system.title,
        system.name,
        system.description,
        system.status,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return searchableText.includes(query);
    });
  }, [complaintList, search]);

  // console.log(
  //   '[ComplaintManagementPage] complaintList:',
  //   complaintList
  // );

  // console.log(
  //   '[ComplaintManagementPage] filteredSystems:',
  //   filteredSystems
  // );

  // Notify parent about search
  useEffect(() => {
    if (onSearch) {
      onSearch(search);
    }
  }, [search, onSearch]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleConfigure = (system) => {
    onConfigure?.(system);

    navigate(`/settings/${system.id ?? 'new'}?step=1`);
  };

  const handleCreate = () => {
   dispatch(setIsEdit({ data: false }));
    onCreateForm?.();

    navigate('/settings/new?step=1');
  };

  return (
    <div
      className="ca-complaint-management-page"
      data-testid="complaint-management-page"
    >
      <PageHeader
        title={title}
        description={description}
        actionLabel={createLabel}
        onAction={handleCreate}
      />

      <div className="ca-search-container">
        <SearchBar
          value={search}
          onChange={handleSearchChange}
          placeholder="Search"
        />
      </div>

      {loading ? (
        <Loading text="Loading systems" />
      ) : error ? (
        <div className="ca-empty">
          <p className="ca-body">
            {typeof error === 'string'
              ? error
              : 'Failed to load complaint types.'}
          </p>
        </div>
      ) : (
        <SystemCardGrid
          systems={filteredSystems}
          onConfigure={handleConfigure}
          onOpen={onOpen}
          onTitleClick={onTitleClick}
          onDescriptionClick={onDescriptionClick}
          emptyMessage={
            search
              ? 'No systems match your search.'
              : 'No systems found.'
          }
        />
      )}
    </div>
  );
}